import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import CloudflareAnalytics from './components/CloudflareAnalytics.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <CloudflareAnalytics />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
